export const chartColorTokens = {
  brand: {
    violet: '#7175d8',
    navy: '#43497b',
    green: '#5ecba1',
    red: '#ff6b69',
    blue: '#45b1e0',
    sand: '#f3ba81',
  },
  semantic: {
    freeMoney: '#abada8',
    others: '#c7cedb',
  },
} as const;

const portfolioBaseColors = [
  chartColorTokens.brand.violet,
  chartColorTokens.brand.navy,
  chartColorTokens.brand.green,
  chartColorTokens.brand.red,
  chartColorTokens.brand.blue,
  chartColorTokens.brand.sand,
];

const portfolioToneSteps = [0, 0.18, -0.12, 0.3, -0.22];

const clampChannel = (value: number) => Math.max(0, Math.min(255, Math.round(value)));

const hexToRgb = (hex: string) => {
  const normalized = hex.replace('#', '');

  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16),
  };
};

const rgbToHex = ({ r, g, b }: { r: number; g: number; b: number }) =>
  `#${[r, g, b].map((channel) => clampChannel(channel).toString(16).padStart(2, '0')).join('')}`;

const mixColor = (source: string, target: string, weight: number) => {
  const from = hexToRgb(source);
  const to = hexToRgb(target);

  return rgbToHex({
    r: from.r + (to.r - from.r) * weight,
    g: from.g + (to.g - from.g) * weight,
    b: from.b + (to.b - from.b) * weight,
  });
};

export const getPortfolioColor = (index: number) => {
  const baseColor = portfolioBaseColors[index % portfolioBaseColors.length];
  const tone = portfolioToneSteps[Math.floor(index / portfolioBaseColors.length) % portfolioToneSteps.length];

  if (tone === 0) {
    return baseColor;
  }

  return tone > 0 ? mixColor(baseColor, '#ffffff', tone) : mixColor(baseColor, '#050c42', Math.abs(tone));
};

export const FREE_MONEY_COLOR = chartColorTokens.semantic.freeMoney;
export const OTHER_POSITIONS_COLOR = chartColorTokens.semantic.others;
